import { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from 'react-hook-form';
import { Box, Divider } from "@material-ui/core";

/** Import entities */
import { CxQuestion, CxQuestionType } from "../../entity/entities";

/** Import reducer */
import { changeErrorCount } from "./inputAnswerSlice";

/** Import utils */
import { AssertUtil } from "../../util/assert-util";

/** Import components */
import { Dropdown } from "./Dropdown";
import { Calendar } from "./Calendar";
import { FreeText } from "./FreeText";
import { RadioButton } from "./RadioButton";
import { SelectScore } from "./SelectScore";
import { CheckBox } from "./CheckBox";
import { Zipcode } from "./Zipcode";

export function Questions(props: {
  pageIndex: number,
  cxQuestions: CxQuestion[],
}) {

  // FIXME 本来はpageIndexを取得するhookを作るべき
  const {
    pageIndex,
    cxQuestions,
  } = props;

  const dispatch = useDispatch();
  const {
    control,
    register,
    formState: { errors },
  } = useForm({
    criteriaMode: 'all',
    mode: 'onBlur',
  });

  const errorCount = Object.keys(errors).length;
  useEffect(() => {
    dispatch(
      changeErrorCount({ errorCount })
    );
  }, [dispatch, errorCount]);

  // 各Questionを種別に応じて作成する
  const Questions = cxQuestions.map((cxQuestion, cxQuestionIndex) => {

    const questionType = cxQuestion.questionType;

    if (questionType === CxQuestionType.SELECT_SCORE) {

      // 5段階評価
      return (
        <Fragment key={cxQuestionIndex}>
          <SelectScore pageIndex={pageIndex} questionIndex={cxQuestionIndex} cxQuestion={cxQuestion} />
          <Box mx={4} mt={3}>
            <Divider />
          </Box>
        </Fragment>
      )
    } else if (questionType === CxQuestionType.FREE_TEXT) {

      // フリーテキスト
      return (
        <Fragment key={`${pageIndex}-${cxQuestionIndex}`}>
          <FreeText
            pageIndex={pageIndex}
            questionIndex={cxQuestionIndex}
            cxQuestion={cxQuestion}
            register={register}
            errors={errors}
          />
          <Box mb={3}></Box>
        </Fragment>
      )

    } else if (questionType === CxQuestionType.DROPDOWN) {

      // ドロップダウン
      return (
        <Fragment key={cxQuestionIndex}>
          <Dropdown pageIndex={pageIndex} questionIndex={cxQuestionIndex} cxQuestion={cxQuestion} />
          <Box mx={4} mt={3}>
            <Divider />
          </Box>
        </Fragment>
      )
    } else if (questionType === CxQuestionType.RADIO_BUTTON) {

      // ラジオボタン
      return (
        <Fragment key={cxQuestionIndex}>
          <RadioButton pageIndex={pageIndex} questionIndex={cxQuestionIndex} cxQuestion={cxQuestion} />
          <Box mx={4} mt={3}>
            <Divider />
          </Box>
        </Fragment>
      )
    } else if (questionType === CxQuestionType.CHECKBOX) {

      // チェックボックス
      return (
        <Fragment key={cxQuestionIndex}>
          <CheckBox pageIndex={pageIndex} questionIndex={cxQuestionIndex} cxQuestion={cxQuestion}/>
          <Box mx={4} mt={3}>
            <Divider />
          </Box>
        </Fragment>
      )
    } else if (questionType === CxQuestionType.ZIPCODE) {

      // 郵便番号
      return (
        <Fragment key={cxQuestionIndex}>
          <Zipcode pageIndex={pageIndex} questionIndex={cxQuestionIndex} cxQuestion={cxQuestion} />
          <Box mb={3}></Box>
        </Fragment>
      )
    } else if (questionType === CxQuestionType.CALENDAR) {
      return (
        <Fragment key={cxQuestionIndex}>
          <Calendar
            control={control}
            pageIndex={pageIndex}
            questionIndex={cxQuestionIndex}
            cxQuestion={cxQuestion}
          />
          <Box mb={3}></Box>
        </Fragment>
      )
    } else {

      AssertUtil.unreachable(questionType);
      return null;
    }
  });

  return (
    <>
      {Questions}
    </>
  )
}
